<template>
  <div class="filter">
    <div class="filter_form">
      <form class="level" @submit.prevent="createCourse">
        <div class="filter_top">
          <span class="left">Общая информация по курсу</span>
          <div class="filter_actions">
            <div class="save_button" @click="$emit('click')">
              <i class="mdi mdi-file-document-box-plus-outline"></i> Управление категориями
            </div>
            <button :disabled="errors.items.length > 0" class="save_button" type="submit">
              <i class="mdi mdi-content-save-outline"></i> Сохранить
            </button>
            <div class="save_button" v-if="!disableButtons" @click="$emit('delete-course')">
              <i class="mdi mdi-folder-remove-outline"></i> В архив
            </div>
            <div
              class="save_button"
              :class="errors.items.length > 0 ? 'disabled' : ''"
              v-if="!disableButtons"
              @click="newCourse.status ? shareCourse(0) : shareCourse(1)"
            >
              <i class="mdi mdi-application-import"></i
              >{{ newCourse.status ? 'Снять с публикации' : 'Опубликовать курс' }}
            </div>
          </div>
        </div>
        <div class="level-left">
          <div class="row">
            <div class="course_preview">
              <label class="preview_label">Превью курса:</label>
              <b-upload
                v-model="file"
                @input="$emit('change-photo', file)"
                :style="{
                  backgroundImage: newCourse.image ? `url(${config.baseUrl + newCourse.image})` : ''
                }"
              >
                <i v-if="!file" class="mdi mdi-image-plus"></i> {{ file ? file.name : 'Загрузить картинку' }}
              </b-upload>
            </div>
            <div class="inputs">
              <b-field
                label="Название курса:"
                class="course_name"
                type="is-info"
                :message="errors.first('name')"
                :class="errors.first('name') ? 'error' : ''"
              >
                <b-input
                  name="name"
                  @input="
                    fieldsChanged.name = true
                    fieldsChanged.leaveAllowed = false
                  "
                  placeholder="Название курса"
                  v-model="newCourse.name"
                  v-validate="{ required: true }"
                ></b-input>
              </b-field>
              <b-field label="Категория курса:" type="is-info" class="category_select">
                <b-select
                  @input="fieldsChanged.leaveAllowed = false"
                  required
                  v-model="newCourse.category_id"
                  placeholder="Категория"
                >
                  <option v-for="(category, i) in categoriesList" :key="i" :value="category.id">{{
                    category.name
                  }}</option>
                </b-select>
              </b-field>
            </div>
          </div>
          <div class="row">
            <b-field label="Статус курса:" type="is-info" class="status_select">
              <b-select
                @input="fieldsChanged.leaveAllowed = false"
                :disabled="true"
                v-model="newCourse.status"
                placeholder="Статус"
              >
                <option value="1">Опубликован</option>
                <option value="0">Черновик</option>
              </b-select>
            </b-field>
            <b-field
              class="numberinput_field"
              label="Длительность курса (дней):"
              :message="errors.first('days')"
              :class="errors.first('days') ? 'error' : ''"
            >
              <b-input
                @input="fieldsChanged.leaveAllowed = false"
                name="days"
                type="number"
                min="1"
                placeholder="Длительность (дней)"
                v-model="newCourse.days_limit"
                v-validate="{ required: true }"
              ></b-input>
            </b-field>
          </div>
        </div>
        <div class="level-right">
          <b-field
            label="Краткая информация по курсу:"
            type="is-info"
            class="textarea_input"
            :message="errors.first('info')"
            :class="errors.first('info') ? 'error' : ''"
          >
            <b-input
              @input="fieldsChanged.leaveAllowed = false"
              name="info"
              type="textarea"
              placeholder="Краткая информация по курсу"
              v-model="newCourse.description"
              v-validate="{ required: true }"
            ></b-input>
          </b-field>
        </div>
      </form>
    </div>

    <CoursePlan
      v-if="disableButtons"
      @abort="$emit('abort')"
      @submit="addStage"
      :new-stage="newStage"
      :stages-list="stagesList"
    />
  </div>
</template>

<script>
import CoursePlan from '@/components/admin/all-courses/CoursePlan'
import { config } from '@/config'

export default {
  components: {
    CoursePlan
  },
  props: {
    fieldsChanged: {
      default: () => {},
      type: Object
    },
    newCourse: {
      default: () => {},
      type: Object
    },
    categoriesList: {
      default: () => [],
      type: Array
    },
    disableButtons: {
      default: () => false,
      type: Boolean
    },
    newStage: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      stagesList: [],
      file: null,
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено'
          },
          category: {
            required: 'Поле не заполнено'
          },
          days: {
            required: 'Поле не заполнено'
          },
          info: {
            required: 'Поле не заполнено'
          }
        }
      }
    }
  },
  computed: {
    config() {
      return config
    }
  },
  methods: {
    createCourse() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('create')
        }
      })
    },
    shareCourse(newStatus) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('share-course', newStatus)
        }
      })
    },
    addStage() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('submit')
        }
      })
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
